// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"cbb2dda0","703":"da800b82","787":"cb617f6a"}[chunkId] + ".chunk.js";
};